import styled from "@emotion/styled";
import { rem } from "@mantine/core";

interface StyledUserProps {
  isDragging: boolean;
  isSelected: boolean;
  isGhosting: boolean;
}

export const StyledUser = styled.div<StyledUserProps>`
  user-select: none;
  padding: 8px;
  margin: 0 0 8px 0;
  min-height: 50px;
  background-color: ${({ isDragging, theme }) =>
    isDragging ? theme.colors.main[5] : theme.colors.main[9]};
  border: 3px solid
    ${({ isSelected, theme }) =>
      isSelected ? theme.colors.main[3] : theme.colors.main[9]};
  opacity: ${({ isGhosting }) => (isGhosting ? 0.8 : 1)};
  color: white;
  position: relative;
`;

export const StyledUsername = styled.p`
  line-height: ${rem(12)};
  font-weight: 200;
`;

export const StyledUsersRole = styled.p`
  font-size: ${rem(14)};
`;

export const StyledSelectionCount = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  border-radius: 100%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1px;
  background-color: ${({ theme }) => theme.colors.main[8]};
  font-weight: 200;
`;
